// extracted by mini-css-extract-plugin
export default {"productDescription":"Oea-z","featuredDescription":"Pea-z","description":"Qea-z","more":"Rea-z","descriptionSku":"Sea-z"};